// Dumb card — no store. Picking the second item means "open items only"; the
// page turns that into the full dashboard reload cycle (R4).
//
//   props:  count      (Number, required)
//           items      (Array, required)  [allLabel, openOnlyLabel]
//           tooltip    (String, required)
//           modelValue (Boolean)          true === items[1] is selected
//   emits:  update:modelValue
import setup from './setup.js';

export default {
  name: 'total-card-with-select',
  props: {
    count: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup,
};
